import { Box, IconButton, Typography } from "@mui/material"
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui-symbols-material/w300"
import { type FC, useState } from "react"

import { CustomerQualityPanel } from "./CustomerQualityPanel"

import type { PreferenceAssociationItem } from "@/screens/CustomerProducts/hooks/useProductPreferenceAssociationList"

interface CustomerQualityPreferencesPanelProps {
  association: PreferenceAssociationItem
  companyId: string
  productId: number
}

export const CustomerQualityPreferencesPanel: FC<CustomerQualityPreferencesPanelProps> = ({
  association,
  companyId,
  productId,
}) => {
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <Box className='rounded-md border border-solid border-gray-400 p-6'>
      <Box className='mb-6 flex items-center justify-between'>
        <Typography className='text-ml font-normal text-gray-900'>Customer Quality Preferences</Typography>
        <IconButton
          size='small'
          onClick={() => setIsExpanded((prev) => !prev)}
          data-testid='customer-product.quality-preferences-panel.expand-button'
        >
          {isExpanded ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
        </IconButton>
      </Box>

      {isExpanded && (
        <CustomerQualityPanel
          key={association.companyProductAssociationLocationId}
          association={association}
          companyId={companyId}
          productId={productId}
        />
      )}
    </Box>
  )
}
